/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createExp } from '../../factoriesAny.js';
export var expDependencies = {
  typedDependencies,
  createExp
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesExp.generated.js
// module id = 537
// module chunks = 2